import { useEffect, useState, useCallback } from "react";
import { getHistoryEntriesByHistoryId } from "../../api/historyService";
import { getHistoryEntriesByPetId } from "../../api/historyService";
export const usePetHistoryEntries = (historyId, petId, mode, trigger, initialPage = 1, initialLimit = 10) => {
    const [historyEntries, setHistoryEntries] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
            setLoading(true);
            try {
              let response;
              if (mode === 'historyId')
              {
                response = await getHistoryEntriesByHistoryId(historyId, page, limit);
              }
              else {
                response = await getHistoryEntriesByPetId(petId, page, limit);
              }
              
              setHistoryEntries(prev => {
              if (append) {
                  return {
                  ...response,
                  data: [...(prev.data || []), ...response.data],
                  };
              }
              // 🔑 Reset pagination when not appending (fresh search or initial load)
              return {
                  ...response,
                  pagination: { ...response.pagination, page }, 
              };
              });
              return response;
            } catch (err) {
                console.error("Failed to fetch history entries:", err);
            } finally {
                setLoading(false);
            }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = historyEntries.pagination.page + 1;
        if (nextPage <= historyEntries.pagination.totalPages) {
        await fetchData(nextPage, historyEntries.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, historyEntries.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { historyEntries, loading, loadMore, searchFunction, resetParent };
};